<template>
  <div class="flex items-center gap-1 mt-2">
    <template v-for="(unit, index) in timeUnits" :key="unit.name">
      <div
        class="relative bg-white/10 backdrop-blur-[12px] rounded-xl w-[70px] h-[54px] flex flex-col items-center justify-center border border-white/20"
      >
        <span class="text-[22px] leading-[26px]">{{ unit.value }}</span>
        <span class="text-[14px] leading-[18px] absolute -bottom-5">
          {{ unit.label }}
        </span>
      </div>
      <span
        v-if="index < timeUnits.length - 1"
        class="text-[22px] leading-[41px]"
        >:</span
      >
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CountDown",
  props: {
    hajjDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      now: new Date(),
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  computed: {
    timeRemaining() {
      const diff = new Date(this.hajjDate).getTime() - this.now.getTime();
      return diff > 0 ? diff : 0;
    },
    days() {
      return Math.floor(this.timeRemaining / (1000 * 60 * 60 * 24));
    },
    hours() {
      return Math.floor(
        (this.timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
    },
    minutes() {
      return Math.floor((this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    },
    seconds() {
      return Math.floor((this.timeRemaining % (1000 * 60)) / 1000);
    },
    timeUnits() {
      return [
        { name: "days", value: this.days, label: "күн" },
        { name: "hours", value: this.hours, label: "сағат" },
        { name: "minutes", value: this.minutes, label: "минут" },
        { name: "seconds", value: this.seconds, label: "секунд" },
      ];
    },
  },
});
</script>
